import { render, staticRenderFns } from "./posList.vue?vue&type=template&id=7ae40a62&scoped=true"
import script from "./posList.vue?vue&type=script&lang=js"
export * from "./posList.vue?vue&type=script&lang=js"
import style0 from "./posList.vue?vue&type=style&index=0&id=7ae40a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae40a62",
  null
  
)

export default component.exports